import {RouteModuleConfiguration} from "../../router/model/UserPermission";

export enum NavigationAccessRoles {
    ROLE_USER = 'ROLE_USER', ROLE_ADMIN = 'ROLE_ADMIN'
}

export interface NavigationConfig {
    title: string,
    href: string,
    activeFunction: (routeName: string) => boolean,
    accessRole?: NavigationAccessRoles[],
    active?: boolean
    module?: RouteModuleConfiguration;
}

export class NavigationItem {
    public title: string;
    public href: string;
    public checkFunction: (routeName: string) => boolean;
    public active: boolean;
    public accessRole: NavigationAccessRoles[] = [NavigationAccessRoles.ROLE_USER];
    public module?: RouteModuleConfiguration;

    constructor(config: NavigationConfig) {
        this.accessRole = config.accessRole ? config.accessRole : this.accessRole;
        this.title = config.title;
        this.href = config.href;
        this.checkFunction = config.activeFunction;
        this.active = config.active ? config.active : false;
        this.module = config.module;
    }

}